import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { combineValidators, isRequired } from 'revalidate';
import { Button, Form, Item, Segment } from 'semantic-ui-react';

import NumberInput from '../../../app/common/form/NumberInput';
import SelectInput from '../../../app/common/form/SelectInput';
import { formatParameterDisp } from '../../../app/common/util/util';
import { RootStoreContext } from '../../../app/stores/rootStore';

const validate = combineValidators({
  schedule: isRequired({ message: 'スケジュールは必須入力です' }),
  reservations: isRequired({ message: '予約数は必須入力です' }),
});

const FrameList: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    submitting,
    schedules,
    scheduleOptions,
    frameFilters,
    createFrame,
  } = rootStore.frameStore;

  const handleFinalFormSubmit = (values: any) => {
    //画面選択項目をセット
    const { ...schedule } = values;
    schedule.reservationDate = formatParameterDisp(
      frameFilters?.reservationDate!
    );
    schedule.reservations = parseInt(schedule.reservations, 10);
    createFrame(schedule);
  };

  return (
    <Segment.Group>
      <Segment>
        <Item.Group divided>
          {schedules.map((s) => (
            <Item key={s.schedule}>
              <Item.Content>{s.schedule}</Item.Content>
              <Item.Content>
                {s.reservations}/{s.capacity}人
              </Item.Content>
            </Item>
          ))}
        </Item.Group>
      </Segment>
      <Segment>
        <FinalForm
          validate={validate}
          onSubmit={handleFinalFormSubmit}
          render={({ handleSubmit, invalid }) => (
            <Form onSubmit={handleSubmit}>
              <Form.Group>
                <Field
                  name='schedule'
                  options={scheduleOptions}
                  component={SelectInput}
                />
                <label style={{ paddingTop: '10px' }}>に</label>
                <Field name='reservations' component={NumberInput} />
                <label style={{ paddingTop: '10px' }}>人予約を</label>
                <Button
                  loading={submitting}
                  disabled={invalid}
                  floated='right'
                  positive
                  type='submit'
                  content='追加する'
                />
              </Form.Group>
            </Form>
          )}
        />
      </Segment>
    </Segment.Group>
  );
};

export default observer(FrameList);
